export default __webpack_public_path__ + "static/media/2.48c0fe16.svg";